import { create } from "zustand";
import type { KeywordState } from "../types/keyword.types";

export const useKeywordStore = create<KeywordState>((set, get) => ({
  apiToken: "",
  setApiToken: (value) => set({ apiToken: value }),

  userUuid: "",
  setUserUuid: (value) => set({ userUuid: value }),

  selectedPlatforms: [],
  setSelectedPlatforms: (value) => {
    const prev = get().selectedPlatforms;
    set({
      selectedPlatforms: typeof value === "function" ? value(prev) : value,
    });
  },

  selectedCountries: [],
  setSelectedCountries: (value) => {
    const prev = get().selectedCountries;
    set({
      selectedCountries: typeof value === "function" ? value(prev) : value,
    });
  },

  selectedLanguages: [],
  setSelectedLanguages: (value) => {
    const prev = get().selectedLanguages;
    set({
      selectedLanguages: typeof value === "function" ? value(prev) : value,
    });
  },

  influencerId: null,
  setInfluencerId: (value) => set({ influencerId: value }),

  isVerified: null,
  setIsVerified: (value) => set({ isVerified: value }),

  dateRange: "last_24_hours",
  setDateRange: (value) => set({ dateRange: value }),

  selectedSubFields: [],
  setSelectedSubFields: (value) => {
    const prev = get().selectedSubFields;
    set({
      selectedSubFields: typeof value === "function" ? value(prev) : value,
    });
  },

  limit: 10,
  setLimit: (value) => set({ limit: value }),
}));
